import { Injectable } from '@angular/core';

export interface NavAttributes {
  [propName: string]: any;
}
export interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
export interface NavBadge {
  text: string;
  variant: string;
}
export interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

const NAVSTUDENTITEMS: NavData[] = [
  {
    name: 'Início',
    url: '/student/dashboard',
    icon: 'fas fa-home',
  }, {
    title: true,
    name: 'Perfil'
  }, {
    name: 'Meus Dados',
    url: '/student/profile',
    icon: 'fas fa-id-card'
  }, {
    name: 'Alterar Senha',
    url: '/student/newpassword',
    icon: 'fas fa-key'
  }, {
    title: true,
    name: 'Secretaria'
  }, {
    name: 'Financeiro',
    url: '/student/finance',
    icon: 'fas fa-money-check-alt',
  }, {
    name: 'Histórico Escolar',
    url: '/student/history',
    icon: 'fas fa-book-reader'
  }, {
    name: 'Nivelamento',
    url: '/student/leveling',
    icon: 'fas fa-chart-line',
  }, {
    title: true,
    name: 'Compra'
  }, {
    name: 'Histórico',
    url: '/student/order/history',
    icon: 'fas fa-shopping-bag'
  },
  
  /* {
    name: 'Agendar 2ª Chamada',
    url: '/student/second-call',
    icon: 'fas fa-calendar-alt'
  }, {
    name: 'Matrícula/Rematrícula',
    url: '/student/enrollment',
    icon: 'fas fa-school'
  },*/ {
    divider: true
  },/* {
    title: true,
    name: 'Extras',
  }, {
    name: 'Fale com o Professor',
    url: '/student/talck-teacher',
    icon: 'fas fa-headset'
  }*/
];

const NAVTEACHERITEMS: NavData[] = [
  /*{
    name: 'Início',
    url: '/teacher/dashboard',
    icon: 'fas fa-home',
  }, */{
    name: 'Pagela Eletrônica',
    url: '/teacher/pagela',
    icon: 'fas fa-book-open',
  }, {
    name: 'Agendas',
    url: '/teacher/scheduler',
    icon: 'fas fa-calendar-alt',
  }, {
    name: 'Meu Holerite',
    url: '/teacher/holerite',
    icon: 'fas fa-search-dollar',
  }, {
    name: 'Perfil',
    url: '/teacher/profile',
    icon: 'fas fa-id-card',
  }, {
    name: 'Alterar Senha',
    url: '/teacher/newpassword',
    icon: 'fas fa-key'
  }
];

const NAVMANAGERITEMS: NavData[] = [
  /*{
    name: 'Início',
    url: '/teacher/dashboard',
    icon: 'fas fa-home',
  }, */{
    name: 'Pagela Eletrônica',
    url: '/teacher/pagela',
    icon: 'fas fa-book-open',
  }, {
    name: 'Consultar Pagela',
    url: '/teacher/consulta-pagela',
    icon: 'fas fa-search',
  }, {
    name: 'Consultar Aluno',
    url: '/teacher/search-student',
    icon: 'fas fa-chart-bar',
  }, {
    name: 'Meu Holerite',
    url: '/teacher/holerite',
    icon: 'fas fa-search-dollar',
  }, {
    name: 'Perfil',
    url: '/teacher/profile',
    icon: 'fas fa-id-card',
  }, {
    name: 'Alterar Senha',
    url: '/teacher/newpassword',
    icon: 'fas fa-key'
  }
];

@Injectable({
  providedIn: 'root'
})
export class MenuService {

   /*
   * Descricao: Retorna as rotas do Módulo Aluno
   */
  getStudentAll(): NavData[]{
    return NAVSTUDENTITEMS;
  }

  /**
   * Descrição: Retorna as rotas do Módulo aluno
   */
  getTeacherAll(): NavData[]{
    return NAVTEACHERITEMS;
  }  

  getManagerAll(): NavData[]{
    return NAVMANAGERITEMS;
  }  

  /*add(menu) {
    NAVITEMS.push(menu);
  }*/
}
